import React from 'react';
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const SubTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: #F4F4F4;
    padding: inherit;
`;

const CardWrapper = styled.div`
    background: white;
    border-radius: 10px;
    width: fit-content;
    margin-top: 2vh;
    margin-bottom: 2vh;
    padding: 2em;
    box-shadow: -5px 5px 5px #88888888;
`;

const CalendarDialogSubtitle = ({serviceName, providerName, ...styleProps}) => {
    return(
        <SubTitleWrapper>
            <CardWrapper>
                <FontAwesomeIcon 
                    icon={['fas', 'address-card']}
                    style={{ marginRight: 15, opacity: 0.6 }}
                    color={'#4AC4D1'}
                    size={"2x"}
                />
                {serviceName}
                <br/>with {providerName}
            </CardWrapper>
        </SubTitleWrapper>
    )
}
export default CalendarDialogSubtitle;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CalendarDialogSubtitle.jsx